import React from 'react';

const Header = () => {
  return <header className="mobile-header"/>
}

export default Header;
